<template>
  <div class="extension-panel">
    <div class="wallet-panel">
      <div :class="['data-description', 'wallet-label', { ['error-label']: !validTarget }]">select target</div>
      <div class="wallet-options">
        <div v-for="option in options" :key="option" class="checkbox-row">
          <label class="container">
            <span class="label-name">{{ option }}</span>
            <input
                type="radio"
                v-model="target"
                :value="option"
                :id="option"
                @change="setWalletTarget(option)"
                class="wallet-type"
                :checked="target === walletTarget">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="cancel-extension" @click="$emit('setExtension', 0)">cancel</div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      messageModuleName: String,
    },

    data() {
      return {
        target: '',
        validTarget: false,
      }
    },

    methods: {
      setWalletTarget(target) {
        this.validateTarget()
        const walletTarget = { _type_options: target }
        this.$emit('passExtensionData', walletTarget)
      },

      validateTarget() {
        this.validTarget = this.target?.length > 0
        this.$emit('validTarget', this.validTarget)
      },
    },

    mounted() {
      this.target = this.walletTarget
      this.validateTarget()
    },

    computed: {
      options: function () {
        let options = ["interests", "birthday", "profile", "home"]
        if (this.currentMerchant.active_referral_program) { options.unshift('referral') }
        if (this.currentMerchant.website) { options.push('shop online') }
        return options
      },

      ...mapState({
        currentMerchant (state) { return state.currentMerchant },
        walletTarget (state) { return state[this.messageModuleName]?.walletTarget }
      }),
    },
  }
</script>